export interface AdobeDataLayerPayload {
  event: string;
  page?: {
    channel: 'group ticket sales';
    type?: string;
    site_section?: string;
  };
  ticketing?: {
    events?: {
      game_pk?: string;
      event_id?: string;
      matchup_desc?: string;
      matchup_dateTime?: string;
      matchup_full?: string;
      ticket_quantity?: string;
      ticket_total_price?: string;
      ticket_unit_price?: string;
      ticket_seat_section?: string;
      ticket_addons?: {
        name?: string;
        price?: string;
      }[];
    }[];
  };
  baseball?: {
    team_id?: string;
  };
}

export enum AdobeDataPages {
  Checkout = 'Checkout',
  Payment = 'Payment',
  Summary = 'Summary',
}
